import styled, { keyframes } from 'styled-components';

export const StyledIsFetchingIndicator = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  color: #6C727F;
  & > * {
    margin-right: 4px;
  }
`;

const spin = keyframes`
  100% { 
    transform: rotate(360deg); 
  } 
`;

export const Spinner = styled.span`
  display: inline-block;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  border-radius: 100%;
  border: 3px solid #eaecef;
  border-top-color: #ced4db;
  animation: ${spin} 500ms infinite linear;
`;
